import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Lenis from "lenis";

export const SmoothScroll = () => {
  const lenisRef = useRef<Lenis | null>(null);
  const { pathname, hash } = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true, autoRaf: true });
    lenisRef.current = lenis;
    return () => { lenis.destroy(); lenisRef.current = null; };
  }, []);

  useEffect(() => {
    const target = hash ? document.querySelector(hash) : null;
    if (target) {
      const go = () => (lenisRef.current ? lenisRef.current.scrollTo(target as HTMLElement, { offset: -96 }) : (target as HTMLElement).scrollIntoView());
      const id = window.setTimeout(go, 80);
      return () => window.clearTimeout(id);
    }
    if (lenisRef.current) lenisRef.current.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};
